<script>
import cloneDeep from "lodash/cloneDeep";
import BgSlider from "./BgSlider.vue";
import CountInput from "@/components/common/CountInput.vue";

import n2c from "@/common/numberToChinese";
export default {
  components: {
    BgSlider,
    CountInput
  },
  data() {
    return {
      typeSource: [
        {
          name: "中心刺激",
          type: "centralFixation"
        },
        {
          name: "旁中心刺激",
          type: "ecCentricFixation"
        },
        {
          name: "眼球震颤",
          type: "nystagmus"
        }
      ],
      type: "centralFixation",
      modelLevels: [
        {
          name: "刺激等级1",
          type: "1"
        },
        {
          name: "刺激等级2",
          type: "2"
        },
        {
          name: "刺激等级3",
          type: "3"
        },
        {
          name: "刺激等级4",
          type: "4"
        },
        {
          name: "刺激等级5",
          type: "5"
        },
        {
          name: "刺激等级6",
          type: "6"
        },
        {
          name: "刺激等级7",
          type: "7"
        },
        {
          name: "刺激等级8",
          type: "8"
        },
        {
          name: "刺激等级9",
          type: "9"
        },
        {
          name: "刺激等级10",
          type: "10"
        }
      ],
      modelLevel: undefined,
      dynamicValidateForm: {
        domains: []
      },
      tempFormData: [],
      modelList: [],
      activeModel: undefined,
      allModelList: {
        nystagmus: [],
        ecCentricFixation: [],
        centralFixation: []
      },
      modelConfig: undefined,
      defaultConfig: undefined
    };
  },
  computed: {
    hasDiff() {
      if (
        JSON.stringify(this.defaultConfig) != JSON.stringify(this.modelConfig)
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    n2c,
    async loadData() {
      const result = await this.$http.getStimulusModeList();
      if (result && result.data) {
        this.allModelList = result.data;
        this.modelList = result.data[this.type];
        this.activeModel = this.modelList[0].modeId;
        this.modelLevel = "1";
      }
      this.loadConfig();
    },
    onSelectModel(value) {
      this.modelLevel = "1";
      this.loadConfig();
    },
    onSelectModelType(type) {
      if (this.allModelList && this.allModelList[type]) {
        this.modelList = this.allModelList[type];
        this.activeModel = this.modelList[0].modeId;
        this.modelLevel = "1";
      }
      this.loadConfig();
    },
    onSelectLevel() {
      this.loadConfig();
    },
    async loadConfig() {
      const params = {
        modeId: this.activeModel,
        level: this.modelLevel
      };
      const result = await this.$http.getStimulusModeById(params);
      this.defaultConfig = cloneDeep(result.resource);
      console.log('???', result)
      if (result.resource) {
        this.modelConfig = result.resource;
      } else {
        const temp = this.modelList.filter(o => o.modeId === this.activeModel);
        this.modelConfig = temp[0].config || {};
      }
    },
    onClickAddBg(indexOfConfig, type) {
      if (indexOfConfig === "image") {
        this.modelConfig[indexOfConfig].imageList.push("");
      } else if (indexOfConfig === "color") {
        const arrLength = this.modelConfig[indexOfConfig].colorList[0].length;
        const newRow = fill(Array(arrLength), "");
        this.modelConfig[indexOfConfig].colorList.push(newRow);
      }
    },
    onClickDelBg(indexOfConfig, index2) {
      if (indexOfConfig === "image") {
        let temp = this.modelConfig[
          indexOfConfig
        ].imageList.filter((o, index) => (index === index2 ? false : true));
        this.modelConfig[indexOfConfig].imageList = temp;
      } else if (indexOfConfig === "color") {
        let temp = this.modelConfig[
          indexOfConfig
        ].colorList.filter((o, index) => (index === index2 ? false : true));
        this.modelConfig[indexOfConfig].colorList = temp;
      }
    },
    async onSaveResult() {
      const data = {
        modeId: this.activeModel,
        level: this.modelLevel,
        config: this.modelConfig
      };
      const result = await this.$http.updateStimulusModeById(data);
      if (result) {
        this.$message.success("保存成功!");
      }
      this.loadConfig();
    }
  }
};
</script>
<template>
  <div class="trainWeightIndex">
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle" style="vertical-align: top;">刺激模式：</span>
        <div class="radioView">
          <span
            v-for="typeInfo in typeSource"
            :key="typeInfo.type + typeInfo.name"
            class="radioCell"
          >
            <el-radio
              v-model="type"
              @change="onSelectModelType"
              :label="typeInfo.type"
            >{{typeInfo.name}}</el-radio>
          </span>
        </div>
      </el-col>
      <el-col :span="12" class="colStyle">
        <span class="searchTitle">刺激背景：</span>
        <span>
          <el-select
            size="medium"
            v-model="activeModel"
            @change="onSelectModel"
            class="selectInputStyle"
          >
            <el-option
              v-for="(model, index) in modelList"
              :key="index + '_modelName'"
              :label="model.name"
              :value="model.modeId"
            />
          </el-select>
        </span>
      </el-col>
      <el-col :span="12" class="colStyle">
        <span class="searchTitle">刺激等级：</span>
        <span>
          <el-select
            size="medium"
            v-model="modelLevel"
            @change="onSelectLevel"
            class="selectInputStyle"
          >
            <el-option
              v-for="(model, index) in modelLevels"
              :key="index + '_gameName'"
              :label="model.name"
              :value="model.type"
            />
          </el-select>
        </span>
      </el-col>
    </el-row>
    <div class="parameterView">
      <el-row :gutter="24" class="parameterTitleView">
        <el-col :span="24">
          <span class="parameterTitle">参数配置</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="parameterCellView">
        <el-col :span="24">
          <div v-for="(config, indexOfConfig) in modelConfig" :key="indexOfConfig">
            <div v-if="config.templateName && config.templateName === 'COLOR_GROUP_INPUT'">
              <div v-for="(item, index2) in config.colorList" :key="index2" class="bg-input-suffix">
                <span class="configItemName">背景颜色组{{n2c(index2 +1)}}</span>
                <el-input
                  v-for="(obj, index3) in item"
                  :key="index3"
                  class="bg-input"
                  size="small"
                  v-model="item[index3]"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-picture"
                    :style="{'color': item[index3], 'background-color': item[index3],'border': '1px #666666 solid', 'line-height':'25px', 'height': '25px','margin':'2px 0'}"
                  ></i>
                </el-input>
                <div
                  v-if="index2 === 0"
                  class="bg-text-button"
                  @click="onClickAddBg(indexOfConfig )"
                >
                  <div class="operationBtn">
                    <i class="el-icon-plus"></i>
                    <p>添加背景颜色组</p>
                  </div>
                </div>
                <div v-else-if="index2 >= config.colorLimitNumber" class="bg-text-button">
                  <div class="operationBtn" @click="onClickDelBg(indexOfConfig,index2)">
                    <i class="el-icon-close"></i>
                    <p>删除背景颜色组</p>
                  </div>
                </div>
              </div>
            </div>
            <BgSlider
              v-if="config.templateName === 'SLIDER_INPUT'"
              :name="config.name"
              v-model="config.value"
              :unit="config.unit"
              :min="config.min"
              :max="config.max"
            />

            <div v-if="config.templateName && config.templateName === 'IMAGE_GROUP_INPUT'">
              <div v-for="(obj, index2) in config.imageList" :key="index2" class="bg-input-suffix">
                <span class="configItemName">背景图片{{n2c(index2+1)}}</span>
                <el-input class="bg-photo-input" size="small" v-model="config.imageList[index2]"></el-input>
                <div
                  v-if="index2 === 0"
                  class="bg-text-button"
                  @click="onClickAddBg(indexOfConfig )"
                >
                  <div class="operationBtn">
                    <i class="el-icon-plus"></i>
                    <p>添加背景图片</p>
                  </div>
                </div>
                <div v-else-if="index2 >= config.imageLimitNumber" class="bg-text-button">
                  <div class="operationBtn" @click="onClickDelBg(indexOfConfig,index2)">
                    <i class="el-icon-close"></i>
                    <p>删除背景图片</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="config.templateName && config.templateName === 'SWITCH_INPUT'"
              class="bg-input-suffix"
            >
              <span class="configItemName">{{config.name}}</span>
              <el-switch
                v-model="config.isClockWise"
                class="switch-bg"
                active-text="顺时针"
                inactive-text="逆时针"
              >></el-switch>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="add-mode">
            <el-button type="primary" @click="onSaveResult" :disabled="hasDiff">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainWeightIndex {
  padding-left: 30px;
  padding-top: 15px;
  .gameSearchForm {
    margin: 0px 0px 10px !important;
    color: rgba(89, 94, 122, 1);
    // width: 00px;
    .colStyle {
      padding: 0 !important;
    }
    .selectInputStyle {
      width: 200px;
    }
    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .radioView {
      width: 75%;
      display: inline-block;
    }
    .radioCell {
      width: 140px;
      margin-bottom: 12px;
      display: inline-block;
    }
  }
  .parameterView {
    border: 1px solid #d5dae0;
    border-radius: 4px;
    width: 95%;
    .parameterTitleView {
      margin: 0px !important;
      background-color: #f2f4f6;
      height: 44px;

      .parameterTitle {
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        color: rgba(34, 39, 46, 1);
      }
    }
    .parameterCellView {
      margin: 0px 0px 10px !important;
      min-height: 140px;
      padding: 10px;

      .parameterCellForm {
        padding-left: 12px;
        .parameterFormItem {
          margin-top: 10px;
        }
      }
      .domainsInput {
        width: 100px;
      }
      .lableView {
        display: inline-block;
        width: 40px;
        margin: auto 5px;
        color: rgba(93, 93, 93, 1);
      }
      .removeIconButton {
        border: none;
      }
    }
    .el-row {
      .configItemName {
        display: inline-block;
        width: 90px;
      }

      .bg-input-suffix {
        margin: 12px 0px;

        .bg-input {
          display: inline-block;
          height: 32px;
          width: 100px;
          padding: 0 5px;
        }

        .bg-photo-input {
          width: 515px;
          display: inline-block;
          height: 32px;

          padding: 0 5px;
        }

        .bg-text-button {
          display: inline-block;
        }

        .switch-bg {
          padding: 0 15px;
        }
      }

      .add-mode {
        text-align: center;
      }

      .operationBtn {
        align-items: center;
        display: flex;
        margin-left: 20px;
        color: #00adc7;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bgConfig/stimulusMode.vue